module.exports = __webpack_public_path__ + "img/swisscom-easypay.9cc18108.png";